let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("13L6t")).then(() => parcelRequire('9YE9p'));